/**
 * 汎用モーダル
 */

let _scroll;

const show = function (target) {
    _scroll.stop();

    document.querySelector(target).classList.add('show');
}

const hide = function () {
    document.querySelectorAll('.modal').forEach(modal => {
        modal.classList.remove('show');
    });

    _scroll.start();
}

export default {
    init: function (scroll /* LocomotiveScroll */) {
        _scroll = scroll;

        document.querySelectorAll('.modal').forEach(modal => {
            modal.querySelectorAll('.modal-close').forEach((el) => {
                el.addEventListener('click', function (e) {
                    e.preventDefault();
                    hide();
                });
            });

            // 背景クリック
            modal.addEventListener('click', function (e) {
                if (e.target === modal
                        || e.target.classList.contains('modal-content')
                        || e.target.classList.contains('container')) {
                    hide();
                }
            });

            // DOMの位置をBODYの最後に移動
            document.body.appendChild(modal);
        });

        document.querySelectorAll('[rel="modal"]').forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();

                const target = link.hasAttribute('data-href')
                    ? link.getAttribute('data-href') : link.getAttribute('href');

                show(target);
            });
        });
    },
    show: show,
    hide: hide,
};
